import style from './menu.module.scss';
import React, {useMemo, useState} from "react";
import {connect} from "react-redux";
import { Bar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const typesChart = [
    {
        type: "chartOne",
        label: "7 DAYS AVERAGE AQI"
    }, {
        type: "chartTwo",
        label: "DAILY AQI CHANGE"
    }];

export function ChartBar({alerts, badges, loaderLogs, currentItem}) {

    return (
        <div className={style.bar}>
            {currentItem && currentItem.data && (
                <Bar data={currentItem.data} options={currentItem.options}/>
            )}
        </div>
    );
}